"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerStatusEnum = void 0;
var BannerStatusEnum;
(function (BannerStatusEnum) {
    BannerStatusEnum["DRAFT"] = "draft";
    BannerStatusEnum["WAITING"] = "waiting";
    BannerStatusEnum["ACTIVE"] = "active";
    BannerStatusEnum["EXPIRED"] = "expired";
})(BannerStatusEnum = exports.BannerStatusEnum || (exports.BannerStatusEnum = {}));
